module.exports = __webpack_public_path__ + "img/middle.f67040b3.png";